// extracted by mini-css-extract-plugin
module.exports = {"content":"real_content__2_o6U"};